// extracted by mini-css-extract-plugin
export default {"control":"Control_control__okYz7"};